import { Icon, Stack, Text } from '@hotjar/hotsauce';
import styled from '@emotion/styled';

const StyledStack = styled(Stack)`
  align-items: flex-start;
`;

const StyledIcon = styled(Icon)`
  flex-shrink: 0;
  height: 20px;
`;

export interface WizardSummaryErrorProps {
  errorMessage: string;
}

export const WidgetSummaryError = ({ errorMessage }: WizardSummaryErrorProps): JSX.Element => {
  return (
    <StyledStack>
      <StyledIcon icon="error" color="text_error" />
      <Text textColor="text_error" textType="body2">
        {errorMessage}
      </Text>
    </StyledStack>
  );
};
